let live_questions = [
  [
    [
      "Conscientiousness_24",
      "Self_Efficacy",
      "Normal",
      "Know how to get things done.",
      "أنا أعرف كيفية إنجاز الأمور.",
      "",
    ],
    [
      "Agreeableness_24",
      "Trust",
      "Reverse",
      "Distrust people.",
      "لا أثق بالناس.",
      "",
    ],
    [
      "Openness_24",
      "Liberalism",
      "Reverse",
      "Believe that we should be tough on crime.",
      "أؤمن أننا يجب أن نكون صارمين باتجاه الجرائم.",
      "",
    ],
    [
      "Neurotism_24",
      "Vulnerability",
      "Reverse",
      "Remain calm under pressure.",
      "أبقى هائا تحت الضغط",
      "",
    ],
    [
      "Extraversion_24",
      "Gregariousness",
      "Reverse",
      "Avoid crowds.",
      "أتجنب الحشود.",
      "",
    ],
    [
      "Conscientiousness_23",
      "Self_Efficacy",
      "Normal",
      "Handle tasks smoothly.",
      "أنا أتعامل مع المهام بسلاسة.",
      "",
    ],
    [
      "Agreeableness_23",
      "Trust",
      "Normal",
      "Trust what people say.",
      "أثق بما يقوله الناس.",
      "",
    ],
    [
      "Openness_23",
      "Liberalism",
      "Reverse",
      "Tend to vote for conservative political candidates.",
      "تميل للتصويت للمرشحين السياسيين المحافظين.",
      "",
    ],
    [
      "Neurotism_23",
      "Vulnerability",
      "Normal",
      "Feel that I'm unable to deal with things.",
      "أشعر أنني غير قادر على التعامل مع الأشياء.",
      "",
    ],
    [
      "Extraversion_23",
      "Gregariousness",
      "Reverse",
      "Prefer to be alone.",
      "افضل أن أكون وحيدا.",
      "",
    ],
    [
      "Conscientiousness_22",
      "Self_Efficacy",
      "Normal",
      "Excel in what I do.",
      "أنا أتميز في ما أقوم به.",
      "",
    ],
    [
      "Agreeableness_22",
      "Trust",
      "Normal",
      "Believe that others have good intentions.",
      "نعتقد أن الآخرين لديهم النوايا الحسنة.",
      "",
    ],
    [
      "Openness_22",
      "Liberalism",
      "Normal",
      "Believe that there is no absolute right and wrong.",
      "أؤمن أنه لا يوجد حق مطلق خطأ مطلق.",
      "",
    ],
    [
      "Neurotism_22",
      "Vulnerability",
      "Normal",
      "Become overwhelmed by events.",
      "اتأثر بالأحداث",
      "",
    ],
    [
      "Extraversion_22",
      "Gregariousness",
      "Normal",
      "Talk to a lot of different people at parties.",
      "اتحدث مع الكثير من الأشخاص المختلفين في الحفلات.",
      "",
    ],
    [
      "Conscientiousness_21",
      "Self_Efficacy",
      "Normal",
      "Complete tasks successfully.",
      "أكمل المهام بنجاح.",
      "",
    ],
    [
      "Agreeableness_21",
      "Trust",
      "Normal",
      "Trust others.",
      "أثق في الآخرين.",
      "",
    ],
    [
      "Openness_21",
      "Liberalism",
      "Normal",
      "Tend to vote for liberal political candidates.",
      "أميل للتصويت للمرشحين السياسيين الليبراليين.",
      "",
    ],
    [
      "Neurotism_21",
      "Vulnerability",
      "Normal",
      "Panic easily.",
      "ينتابني الذعر بسهولة",
      "",
    ],
    [
      "Extraversion_21",
      "Gregariousness",
      "Normal",
      "Love large parties.",
      "احب الحفلات الكبيرة",
      "",
    ],
    [
      "Conscientiousness_20",
      "Self_Discipline",
      "Reverse",
      "Have difficulty starting tasks.",
      "لدي صعوبة في بدء المهام.",
      "",
    ],
    [
      "Agreeableness_20",
      "Sympathy",
      "Reverse",
      "Try not to think about the needy.",
      "احاول ألا أفكر في المحتاجين.",
      "",
    ],
    [
      "Openness_20",
      "Intellect",
      "Reverse",
      "Am not interested in theoretical discussions.",
      "لست مهتما في المناقشات النظرية.",
      "",
    ],
    [
      "Neurotism_20",
      "Self_Consciousness",
      "Reverse",
      "Am not bothered by difficult social situations.",
      "لا أنزعج من المواقف الاجتماعية الصعبة.",
      "",
    ],
    [
      "Extraversion_20",
      "Friendliness",
      "Reverse",
      "Keep others at a distance.",
      "ابقاء الآخرين على مسافة منك",
      "",
    ],
    [
      "Conscientiousness_19",
      "Self_Discipline",
      "Reverse",
      "Waste my time.",
      "أنا أضيع وقتي.",
      "",
    ],
    [
      "Agreeableness_19",
      "Sympathy",
      "Reverse",
      "Am not interested in other people's problems.",
      "لست مهتما بمشاكل الآخرين.",
      "",
    ],
    [
      "Openness_19",
      "Intellect",
      "Reverse",
      "Have difficulty understanding abstract ideas.",
      "أجد صعوبة في فهم الأفكار المجردة.",
      "",
    ],
    [
      "Neurotism_19",
      "Self_Consciousness",
      "Normal",
      "Only feel comfortable with friends.",
      "أشعر بالراحة فقط مع الأصدقاء.",
      "",
    ],
    [
      "Extraversion_19",
      "Friendliness",
      "Reverse",
      "Avoid contacts with others.",
      "تجنب الاتصال مع الآخرين.",
      "",
    ],
    [
      "Conscientiousness_18",
      "Self_Discipline",
      "Normal",
      "Carry out my plans.",
      "أنفذ خططي.",
      "",
    ],
    [
      "Agreeableness_18",
      "Sympathy",
      "Normal",
      "Feel sympathy for those who are worse off than myself.",
      "أشعر بالتعاطف مع أولئك الذين هم أسوأ مني.",
      "",
    ],
    [
      "Openness_18",
      "Intellect",
      "Reverse",
      "Avoid philosophical discussions.",
      "أتجنب المناقشات الفلسفية.",
      "",
    ],
    [
      "Neurotism_18",
      "Self_Consciousness",
      "Normal",
      "Am afraid to draw attention to myself.",
      "أخشى أن ألفت الانتباه إلى نفسي.",
      "",
    ],
    [
      "Extraversion_18",
      "Friendliness",
      "Normal",
      "Feel comfortable around people.",
      "أشعر بالراحة حول الناس.",
      "",
    ],
    [
      "Conscientiousness_17",
      "Self_Discipline",
      "Normal",
      "Am always prepared.",
      "أنا دائما على استعداد.",
      "",
    ],
    [
      "Agreeableness_17",
      "Sympathy",
      "Normal",
      "Sympathize with the homeless.",
      "اتعاطف مع المشردين.",
      "",
    ],
    [
      "Openness_17",
      "Intellect",
      "Normal",
      "Love to read challenging material.",
      "أحب أن أقرأ المواد الصعبة.",
      "",
    ],
    [
      "Neurotism_17",
      "Self_Consciousness",
      "Normal",
      "Find it difficult to approach others.",
      "أجد صعوبة في الاقتراب من الآخرين.",
      "",
    ],
    [
      "Extraversion_17",
      "Friendliness",
      "Normal",
      "Make friends easily.",
      "تكوين صداقات بسهولة.",
      "",
    ],
    [
      "Conscientiousness_16",
      "Orderliness",
      "Reverse",
      "Leave my belongings around.",
      "اترك اشيائي مبعثرة",
      "",
    ],
    [
      "Agreeableness_16",
      "Morality",
      "Reverse",
      "Obstruct others' plans.",
      "اعرقل خطط الآخرين.",
      "",
    ],
    [
      "Openness_16",
      "Imagination",
      "Normal",
      "Like to get lost in thought.",
      "أحب أن أشرد في التفكير.",
      "",
    ],
    [
      "Neurotism_16",
      "Immoderation",
      "Reverse",
      "Am able to control my cravings.",
      "أنا قادر على السيطرة على رغباتي ",
      "",
    ],
    [
      "Extraversion_16",
      "Excitement_Seeking",
      "Normal",
      "Act wild and crazy.",
      "التصرف بجنون.",
      "",
    ],
    [
      "Conscientiousness_15",
      "Orderliness",
      "Reverse",
      "Leave a mess in my room.",
      "اترك فوضى في غرفتي.",
      "",
    ],
    [
      "Agreeableness_15",
      "Morality",
      "Reverse",
      "Take advantage of others.",
      "استغل الآخرين.",
      "",
    ],
    [
      "Openness_15",
      "Imagination",
      "Normal",
      "Love to daydream.",
      "أحب أحلام اليقظة.",
      "",
    ],
    [
      "Neurotism_15",
      "Immoderation",
      "Reverse",
      "Easily resist temptations.",
      "أقاوم الإغراءات بسهولة",
      "",
    ],
    [
      "Extraversion_15",
      "Excitement_Seeking",
      "Normal",
      "Enjoy being reckless.",
      "استمتع بالتهور.",
      "",
    ],
    [
      "Conscientiousness_14",
      "Orderliness",
      "Reverse",
      "Often forget to put things back in their proper place.",
      "أنسى في كثير من الأحيان وضع الأشياء مرة أخرى في مكانها الصحيح.",
      "",
    ],
    [
      "Agreeableness_14",
      "Morality",
      "Reverse",
      "Cheat to get ahead.",
      "أقوم بالغش لأتفوق.",
      "",
    ],
    [
      "Openness_14",
      "Imagination",
      "Normal",
      "Enjoy wild flights of fantasy.",
      "استمتع بالرحلات البرية من الخيال.",
      "",
    ],
    [
      "Neurotism_14",
      "Immoderation",
      "Reverse",
      "Rarely overindulge.",
      "نادرا ما أفرط في فعل الأمور.",
      "",
    ],
    [
      "Extraversion_14",
      "Excitement_Seeking",
      "Normal",
      "Seek adventure.",
      "اسعى وراء المغامرات",
      "",
    ],
    [
      "Conscientiousness_13",
      "Orderliness",
      "Normal",
      "Like to tidy up.",
      "أحب الترتيب.",
      "",
    ],
    [
      "Agreeableness_13",
      "Morality",
      "Reverse",
      "Use others for my own ends.",
      "استخدم الآخرين لغاياتي الخاصة.",
      "",
    ],
    [
      "Openness_13",
      "Imagination",
      "Normal",
      "Have a vivid imagination.",
      "لدي خيال حيوي",
      "",
    ],
    [
      "Neurotism_13",
      "Immoderation",
      "Normal",
      "Go on binges.",
      "افرط في فعل الأمور",
      "",
    ],
    [
      "Extraversion_13",
      "Excitement_Seeking",
      "Normal",
      "Love excitement.",
      "حماس الحب",
      "",
    ],
  ],
  [
    [
      "Conscientiousness_12",
      "Dutifulness",
      "Reverse",
      "Break my promises.",
      "اخلف وعودي",
      "",
    ],
    [
      "Agreeableness_12",
      "Modesty",
      "Reverse",
      "Boast about my virtues.",
      "أتباهى بفضائلى",
      "",
    ],
    [
      "Openness_12",
      "Emotionality",
      "Reverse",
      "Don't understand people who get emotional.",
      "لا أتفهم الناس العاطفيين.",
      "",
    ],
    [
      "Neurotism_12",
      "Depression",
      "Reverse",
      "Feel comfortable with myself.",
      "أشعر بالراحة مع نفسي.",
      "",
    ],
    [
      "Extraversion_12",
      "Cheerfulness",
      "Normal",
      "Look at the bright side of life.",
      "انظر إلى الجانب المشرق من الحياة.",
      "",
    ],
    [
      "Conscientiousness_11",
      "Dutifulness",
      "Reverse",
      "Break rules.",
      "أكسر القواعد",
      "",
    ],
    [
      "Agreeableness_11",
      "Modesty",
      "Reverse",
      "Have a high opinion of myself.",
      "امدح نفسي",
      "",
    ],
    [
      "Openness_11",
      "Emotionality",
      "Reverse",
      "Rarely notice my emotional reactions.",
      "نادرا ما ألاحظ ردود أفعالي العاطفية.",
      "",
    ],
    [
      "Neurotism_11",
      "Depression",
      "Normal",
      "Am often down in the dumps.",
      "أنا في كثير من الأحيان محبط",
      "",
    ],
    [
      "Extraversion_11",
      "Cheerfulness",
      "Normal",
      "Love life.",
      "أحب الحياة",
      "",
    ],
    [
      "Conscientiousness_10",
      "Dutifulness",
      "Normal",
      "Tell the truth.",
      "أقول الحقيقه.",
      "",
    ],
    [
      "Agreeableness_10",
      "Modesty",
      "Reverse",
      "Think highly of myself.",
      "أفكر كثيرا بنفسي",
      "",
    ],
    [
      "Openness_10",
      "Emotionality",
      "Normal",
      "Feel others' emotions.",
      "أشعر بمشاعر الآخرين.",
      "",
    ],
    [
      "Neurotism_10",
      "Depression",
      "Normal",
      "Dislike myself.",
      "لا أحب نفسي",
      "",
    ],
    [
      "Extraversion_10",
      "Cheerfulness",
      "Normal",
      "Have a lot of fun.",
      "أحظى بالكثير من المرح",
      "",
    ],
    [
      "Conscientiousness_9",
      "Dutifulness",
      "Normal",
      "Keep my promises.",
      "احافظ على وعودي.",
      "",
    ],
    [
      "Agreeableness_9",
      "Modesty",
      "Reverse",
      "Believe that I am better than others.",
      "اؤمن أنني أفضل من الآخرين",
      "",
    ],
    [
      "Openness_9",
      "Emotionality",
      "Normal",
      "Experience my emotions intensely.",
      "لدي مشاعر جياشة.",
      "",
    ],
    [
      "Neurotism_9",
      "Depression",
      "Normal",
      "Often feel blue.",
      "غالبا ما أشعر بالحزن",
      "",
    ],
    [
      "Extraversion_9",
      "Cheerfulness",
      "Normal",
      "Radiate joy.",
      "أنشر البهجة",
      "",
    ],
    [
      "Conscientiousness_8",
      "Cautiousness",
      "Reverse",
      "Act without thinking.",
      "اتصرف دون تفكير.",
      "",
    ],
    [
      "Agreeableness_8",
      "Cooperation",
      "Reverse",
      "Get back at others.",
      "أنتقم من الآخرين",
      "",
    ],
    [
      "Openness_8",
      "Artistic Interests",
      "Reverse",
      "Do not enjoy going to art museums.",
      "لا أستمتع الذهاب إلى المتاحف الفنية.",
      "",
    ],
    [
      "Neurotism_8",
      "Anxiety",
      "Normal",
      "Get stressed out easily.",
      "أتوتر بسهولة",
      "",
    ],
    [
      "Extraversion_8",
      "Assertiveness",
      "Reverse",
      "Wait for others to lead the way.",
      "أنتظر أن يقود الآخرون الطريق.",
      "",
    ],
    [
      "Conscientiousness_7",
      "Cautiousness",
      "Reverse",
      "Rush into things.",
      "اتسرع في الامور.",
      "",
    ],
    [
      "Agreeableness_7",
      "Cooperation",
      "Reverse",
      "Insult people.",
      "أهين الناس",
      "",
    ],
    [
      "Openness_7",
      "Artistic Interests",
      "Reverse",
      "Do not like poetry.",
      "لا أحب الشعر.",
      "",
    ],
    [
      "Neurotism_7",
      "Anxiety",
      "Normal",
      "Am afraid of many things.",
      "أخشى من أشياء كثيرة.",
      "",
    ],
    [
      "Extraversion_7",
      "Assertiveness",
      "Normal",
      "Take control of things.",
      "أنا أسيطر على الأمور.",
      "",
    ],
    [
      "Conscientiousness_6",
      "Cautiousness",
      "Reverse",
      "Make rash decisions.",
      "اتخذ قرارات متهورة.",
      "",
    ],
    [
      "Agreeableness_6",
      "Cooperation",
      "Reverse",
      "Yell at people.",
      "أصرخ في وجه الناس.",
      "",
    ],
    [
      "Openness_6",
      "Artistic Interests",
      "Normal",
      "See beauty in things that others might not notice.",
      "أرى الجمال في الأشياء التي قد لا يلاحظها الآخرون.",
      "",
    ],
    [
      "Neurotism_6",
      "Anxiety",
      "Normal",
      "Fear for the worst.",
      "أخاف قدوم الأسوأ",
      "",
    ],
    [
      "Extraversion_6",
      "Assertiveness",
      "Normal",
      "Try to lead others.",
      "أحاول أن أقود الآخرين.",
      "",
    ],
    [
      "Conscientiousness_5",
      "Cautiousness",
      "Reverse",
      "Jump into things without thinking.",
      "أتسرع دون تفكير.",
      "",
    ],
    [
      "Agreeableness_5",
      "Cooperation",
      "Reverse",
      "Love a good fight.",
      "أحب القتال الجيد.",
      "",
    ],
    [
      "Openness_5",
      "Artistic Interests",
      "Normal",
      "Believe in the importance of art.",
      "أؤمن في أهمية الفن.",
      "",
    ],
    [
      "Neurotism_5",
      "Anxiety",
      "Normal",
      "Worry about things.",
      "دائما ما اقلق حيال الأمور",
      "",
    ],
    [
      "Extraversion_5",
      "Assertiveness",
      "Normal",
      "Take charge.",
      "أنا أتولى المسؤولية.",
      "",
    ],
    [
      "Conscientiousness_4",
      "Achievement_Striving",
      "Reverse",
      "Do just enough work to get by.",
      "أقوم بالعمل اللازم فقط لانهاء الشيء. ",
      "",
    ],
    [
      "Agreeableness_4",
      "Altruism",
      "Reverse",
      "Take no time for others.",
      "لا أعطي أي وقت للآخرين.",
      "",
    ],
    [
      "Openness_4",
      "Adventurousness",
      "Reverse",
      "Am attached to conventional ways.",
      "أنا متعلق بالطرق التقليدية.",
      "",
    ],
    [
      "Neurotism_4",
      "Anger",
      "Reverse",
      "Am not easily annoyed.",
      "لا أنزعج بسهولة",
      "",
    ],
    [
      "Extraversion_4",
      "Activity Level",
      "Reverse",
      "Like to take it easy.",
      "أنا أحب أن آخذ الأمور ببساطة",
      "",
    ],
    [
      "Conscientiousness_3",
      "Achievement_Striving",
      "Reverse",
      "Put little time and effort into my work.",
      "أضع القليل من الوقت والجهد في عملي.",
      "",
    ],
    [
      "Agreeableness_3",
      "Altruism",
      "Reverse",
      "Am indifferent to the feelings of others.",
      "أنا غير مبال لمشاعر الآخرين.",
      "",
    ],
    [
      "Openness_3",
      "Adventurousness",
      "Reverse",
      "Dislike changes.",
      "أكره التغيير",
      "",
    ],
    ["Neurotism_3", "Anger", "Normal", "Lose my temper.", "أفقد أعصابي", ""],
    [
      "Extraversion_3",
      "Activity Level",
      "Normal",
      "Do a lot in my spare time.",
      "أفعل الكثير في وقت فراغي.",
      "",
    ],
    [
      "Conscientiousness_2",
      "Achievement_Striving",
      "Normal",
      "Work hard.",
      "اعمل بجد.",
      "",
    ],
    [
      "Agreeableness_2",
      "Altruism",
      "Normal",
      "Love to help others.",
      "أحب مساعدة الآخرين",
      "",
    ],
    [
      "Openness_2",
      "Adventurousness",
      "Reverse",
      "Prefer to stick with things that I know.",
      "أفضل الإلتزام بالأمور التي أعرفها",
      "",
    ],
    [
      "Neurotism_2",
      "Anger",
      "Normal",
      "Get irritated easily.",
      "يمكن استفزازي بسهولة.",
      "",
    ],
    [
      "Extraversion_2",
      "Activity Level",
      "Normal",
      "Am always on the go.",
      "أنا في حالة نشاط دائم",
      "",
    ],
    [
      "Conscientiousness_1",
      "Achievement_Striving",
      "Normal",
      "Do more than what's expected of me.",
      "افعل أكثر مما هو متوقع مني.",
      "",
    ],
    [
      "Agreeableness_1",
      "Altruism",
      "Normal",
      "Am concerned about others.",
      "أنا قلق حيال الآخرين",
      "",
    ],
    [
      "Openness_1",
      "Adventurousness",
      "Normal",
      "Prefer variety to routine.",
      "أفضل التنوع على الروتين",
      "",
    ],
    ["Neurotism_1", "Anger", "Normal", "Get angry easily.", "أغضب بسهولة.", ""],
    [
      "Extraversion_1",
      "Activity Level",
      "Normal",
      "Am always busy.",
      "انا دائما مشغول.",
      "",
    ],
  ],
];

export function add_big5_questions(assessment, test = true, part = 1) {
  // export correct json

  (test ? live_questions[part].slice(1, 3) : live_questions[part]).forEach(
    (question) => {
      assessment.pages.push({
        name: question[0],
        elements: [
          {
            title: {
              en: "How accurately does this statement describe you?",
              ar: "ما مدى دقة وصف هذه العبارة لك؟",
            },
            name: question[0],
            type: "radiogroup",
            isRequired: true,
            renderAs: "likert",
            otherText: { en: "I don't understand the question.", ar: "السؤال" },
            otherErrorText: {
              en: "Please describe briefly what it is you are unsure about.",
              ar: "يرجى تقديم وصف موجز لما هو غير متأكد.",
            },
            scoring: question[1],
            choices: [
              {
                value: "statement",
                text: { en: question[3], ar: question[4] },
              },
              {
                value: "disagree_strong",
                text: { en: "strongly disagree", ar: "لا أوافق بشدة" },
              },
              {
                value: "disagree",
                text: { en: "slightly disagree", ar: "لا أوافق قليلا" },
              },
              { value: "neutral", text: { en: "neutral", ar: "محايد" } },
              {
                value: "agree",
                text: { en: "slightly agree", ar: "موافق قليلا" },
              },
              {
                value: "agree_strong",
                text: { en: "strongly agree", ar: "موافق بشدة" },
              },
            ],
          },
        ],
      });
    },
  );
}
